// ---------------------------------------------------------------------------
// /paintings/timemachine-2025 — wrapper for the Time Machine 2025
// editorial exhibition page.
//
// All content (hero, quote, intro, paintings, closing, SEO, run dates,
// venue) lives in src/data/exhibitions/timeMachine2025Exhibition.js.
// The actual rendering is handled by the reusable ExhibitionPage
// component. To create another exhibition page, copy this file, swap
// the imported data module, and register a new route in TheRoutes.js.
// ---------------------------------------------------------------------------

import React from "react";
import ExhibitionPage from "../../components/ExhibitionPage";
import exhibition from "../../data/exhibitions/timeMachine2025Exhibition";

const TimeMachine2025 = () => <ExhibitionPage data={exhibition} />;

export default TimeMachine2025;
